import { __, always, cond, is, lte, T } from 'ramda';

export const formatValue = (value) => {
  if (is(Number, value)) {
    return value;
  }

  const updatedValue = +`${value}`.replace(',', '.');

  return isNaN(updatedValue) ? null : updatedValue;
};

export const parseData = (data = [], series = []) =>
  data.map((item) => {
    const newItem = { ...item };

    series.forEach((serie) => {
      newItem[serie] = formatValue(newItem[serie]);
    });

    return newItem;
  });

export const getSize = (sizeProp, defaultValue) => (item) => {
  const value = item[sizeProp] || defaultValue;

  return is(Number, value) ? `${value}px` : `${value}`;
};

export const numTicksForHeight = cond([
  [lte(__, 300), always(3)],
  [(height) => 300 < height && height <= 600, always(5)],
  [T, always(10)],
]);

export const numTicksForWidth = cond([
  [lte(__, 300), always(2)],
  [(width) => 300 < width && width <= 400, always(5)],
  [T, always(10)],
]);
